var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContentRating7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81034 -0.258621C10.4311 -0.258621 19.0517 -0.258621 27.6724 -0.258621C28.3422 0.252604 29.0319 0.769846 29.7414 1.2931C29.7414 10.2586 29.7414 19.2242 29.7414 28.1897C29.0517 28.5345 28.5345 29.0517 28.1897 29.7414C19.2242 29.7414 10.2586 29.7414 1.2931 29.7414C0.948274 29.0517 0.431034 28.5345 -0.258621 28.1897C-0.258621 19.3966 -0.258621 10.6034 -0.258621 1.81034C0.25862 0.948274 0.948274 0.25862 1.81034 -0.258621Z",
    fill: "#4C8FB9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05173 3.87931C12.9216 3.36619 16.8871 3.19378 20.9483 3.36207C21.1068 4.85454 20.9344 6.23385 20.431 7.5C20.431 6.29312 20.431 5.08621 20.431 3.87931C16.638 3.87931 12.8448 3.87931 9.05173 3.87931Z",
    fill: "#A8C8DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05173 3.87931C12.8448 3.87931 16.638 3.87931 20.431 3.87931C20.431 5.08621 20.431 6.29312 20.431 7.5C18.2599 13.6687 16.1909 19.8756 14.2241 26.1207C12.7317 26.2792 11.3524 26.1068 10.0862 25.6034C11.9993 19.7782 14.0683 14.0024 16.2931 8.27586C13.8855 8.01766 11.4716 7.93148 9.05173 8.01724C9.05173 6.63791 9.05173 5.25864 9.05173 3.87931Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0862 25.6034C11.3524 26.1068 12.7317 26.2792 14.2241 26.1207C12.7473 26.7948 11.1955 26.7948 9.56897 26.1207C9.6329 25.8069 9.8053 25.6345 10.0862 25.6034Z",
    fill: "#B4D0E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentRating7);
export default __webpack_public_path__ + "static/media/ic_content_rating_7.640569b7be2e53cfd4c7e69018f5ab6a.svg";
export { ForwardRef as ReactComponent };